import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css"; // Import Swiper styles
import "swiper/css/navigation"; // For navigation (but we will disable it)
import "swiper/css/pagination"; // For pagination (but we will disable it)
import { Autoplay } from "swiper"; // Import required modules
import "./Portfolio.css";

const shortsData = [
  { id: "1", title: "48,081,406 Views", url: "https://www.youtube.com/embed/k7nf-iDm2VI" },
  { id: "2", title: "28,372,121 Views", url: "https://www.youtube.com/embed/nAVVlo_JEto" },
  { id: "3", title: "89,818,795 Views", url: "https://www.youtube.com/embed/q_bcKOfcFlk" },
  { id: "4", title: "67,494,989 Views", url: "https://www.youtube.com/embed/_O5u7vrdv4c" },
  { id: "5", title: "10,594,133 Views", url: "https://www.youtube.com/embed/vmWmqYUZWOs" },
  { id: "6", title: "91,330,683 Views", url: "https://www.youtube.com/embed/B8uBA43ECTw" },
  { id: "7", title: "41,232,835 Views", url: "https://www.youtube.com/embed/-jSP_39709s" },
  { id: "8", title: "40,801,687 Views", url: "https://www.youtube.com/embed/yLqZvBj4WWo" },
  { id: "9", title: "34,557,395 Views", url: "https://www.youtube.com/embed/4KRXp2-ehD4" }
];

const YouTubeShortsGallery = () => {
  const swiperRef = useRef(null); // Ref for Swiper instance
  const iframeRefs = useRef({}); // Store iframe refs for each video
  const [isMobile, setIsMobile] = useState(false);
  const [isVideoPlaying, setIsVideoPlaying] = useState(false); // Track video playing state

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768); // Check if mobile device
  };

  const handleVideoPlay = () => {
    setIsVideoPlaying(true); // Mark video as playing
    if (swiperRef.current) {
      swiperRef.current.swiper.autoplay.stop(); // Stop the autoplay when a video plays
    }
  };

  const handleVideoPause = () => {
    setIsVideoPlaying(false); // Mark video as paused
    if (swiperRef.current) {
      swiperRef.current.swiper.autoplay.start(); // Restart the autoplay when video is paused
    }
  };

  const goToNext = () => {
    if (swiperRef.current) {
      swiperRef.current.swiper.slideNext(); // Go to the next slide
    }
  };

  const goToPrev = () => {
    if (swiperRef.current) {
      swiperRef.current.swiper.slidePrev(); // Go to the previous slide
    }
  };

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="gallery-container">
      <h2 className="gallery-title">Our Viral Video Edits</h2>
      <Swiper
        ref={swiperRef}
        spaceBetween={8}
        slidesPerView={1} // Default for very small screens
        loop={shortsData.length > 2} // Enable loop only if enough slides exist
        centeredSlides={true}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false, // Autoplay should not stop after interaction
          pauseOnMouseEnter: true, // Pause autoplay when mouse enters
        }}
        allowTouchMove={true}
        breakpoints={{
          1024: { slidesPerView: 7, spaceBetween: 25 },
          768: { slidesPerView: 3, spaceBetween: 16 },
          320: { // ✅ Now even the smallest screens get 2 slides
            slidesPerView: 2,
            spaceBetween: 8,
            centeredSlides: false, 
            loop: shortsData.length > 2,
            allowTouchMove: false,
          }
        }}
        modules={[Autoplay]}
        className="shorts-slider"
        pagination={false}
        navigation={false}
      >
        {shortsData.map((short) => (
          <SwiperSlide key={short.id} className="short-item">
            <iframe
              ref={(el) => (iframeRefs.current[short.id] = el)}
              src={`${short.url}?autoplay=0&mute=1`}
              title={short.title}
              className="short-frame"
              allowFullScreen
              onPlay={handleVideoPlay}
              onPause={handleVideoPause}
            ></iframe>
            <div className="short-title">{short.title}</div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Mobile Navigation Arrows */}
      {isMobile && (
        <div className="swiper-navigation">
          <button className="swiper-nav-prev" onClick={goToPrev}>{"<"}</button>
          <button className="swiper-nav-next" onClick={goToNext}>{">"}</button>
        </div>
      )}
    </div>
  );
};

export default YouTubeShortsGallery;
